module.exports = __webpack_public_path__ + "img/Cuban Bowl-Pork.032c78de.jpg";